export const blockComponents = [
  'PartnerContact', // CT05 - Partner Contact
  'AccreditationBlock', // CT06 - Accreditation Block
  'SmallCta', // CT18 - Small CTA
  'SmallCtaPageWidth', // CT18 - Small CTA
  'Feature', // CT19 - Large CTA
  'AddressMap', // CT25 - Address Map
  'ArticleList', // CT 28 - Article List / CT39 - Related Articles / CT56 - Latest News / CT58 - Related News / CT68 - Related Events / CT69 - Upcoming Events
  'TestimonialCarousel', // CT29 - Testimonials Carousel
  'StaffListing', // CT34 - Staff Listing
  'ArticleListing', // CT 36 - Insights Listing / CT55 - News Listing
  'FeatureRight', // CT46 - Feature Right
  'FeatureLeft', // CT47 - Feature Left
  'ContactCta', // CT50 - Contact CTA
  'EventSignup', // CT65 - Events Signup Form
  'EventUpdate', // CT70 - Events Updates Sign Up
  'EbriefingSignup', // CT72 - eBriefing Sign Up
  'PartnerContactCta', // CT73 - Partner Contact CTA
  'InlineForm', // CT74 - Inline form
  'PartnerNewsCTA', // CT75 - Partner News CTA
  'CalloutBlock', // CT77 Callout block
  'TeamProfile', // CT82 - Team Profile
  'AccreditationDetailHeader', // CT84 Accreditation Detail
  'VouchedForWidget', // CT91 - VouchedFor Widget
];

export const normalComponents = [
  'PartnerHeader', // CT03 - Partner Header
  'PartnerBio', // CT04 - Partner Bio
  'FindAnAdvisor', // CT12 - Find a Partner Block
  'IFrame',
  'ContentHeader', // CT14 - Content Header
  '', // CT15 - Insights - Intro Text
  'BasicText', // CT16 - Basic Text
  'TruncatedText', // CT17 - Truncated Text
  'Image', // CT20 - Image
  'ImageGallery', // CT21 - Image Gallery
  'Video', // CT22 - Video
  'QuoteWide', // CT23 - Quote Block
  'QuoteNarrow', // CT23 - Quote Block
  'Table', // CT24 - Basic Responsive Table
  'ThirdContentCardList', // CT26 - 1/3 Content Card List
  'HalfContentCardList', // CT27 - 1/2 Content Card List
  'SjpGuarantee', // CT31 - SJP Guarantee
  'Disclaimer', // CT32 - Disclaimer
  'ArticleHeader', // CT 37 - Insights Header
  'SocialShareContentWidth', // CT38 - Social Share
  'SocialShare', // CT38 - Social Share
  'AnchorLinks', // CT40 - Anchor Links
  'MarketOverview', // CT41 - IMU World Markets
  '', // CT42 - IMU Stock and Ratio Tables
  'StaffSearch', // CT44 - Staff Search
  'StaffHeader', // CT45 - Staff Header
  'ContactCard',
  'Download', // CT48 - Download
  'Accordion', // CT49 - Accordion
  'IFrame', // CT51 - iFrame
  'HomepageHeader', // CT52 - Homepage Header
  '', // CT55 - News Listing
  '', // CT56 - Latest News
  'ContentDividerFullWidth', // CT63 - Divider
  'ContentDividerPageWidth', // CT63 - Divider
  'EventHeader', // CT64 - Events Header
  'EventListing', // CT66 - Events Listing
  'EventFilters', // CT67 - Events Filter
  'EventGrouping', // CT71 - Event Grouping
  'AccordionFullWidth',
  'AccordionPageWidth',
  'PromoCarouselCenter', // CT76 - Promo
  'PromoCarouselLeft', // CT76 - Promo
  'OneThirdImageTextLeft', // CT78 -1/3 Image Text Block left
  'OneThirdImageTextRight', // CT78 -1/3 Image Text Block right,
  'ArticleSection', // no CT ?
  'FundCentre', // Fund Centre - Instinct difraas embed
];

const otherComponents = [
  'SubdomainNavigation', // CT01 Subdomain Navigation
  'SubdomainFooter', // CT02 - Subdomain Footer
  'ArrangeMeeting', // CT05 - Partner Contact
  'RequestCallback', // CT05 - Partner Contact
  'MakeEnquiry', // CT05 - Partner Contact
  'PersistentContactBar', // CT07 - Persistant contact bar
  'ContactFormOverlay', // CT08 - Contact form overlay
  'EbriefingSignupFormOverlay', // CT09 - E-briefings sign up overlay
  'T2Navigation', // CT10 - T2 Navigation
  'T2Footer', // CT11 - T2 Footer
  'Breadcrumb', // CT13 - Breadcrumb,
  'CookiePolicy', // CT43 - Cookie Policy
  'ArchivedArticlePopUp', // CT59 - Insights Article Pop up
  'InsightsFeedbackForm', // CT81 - Insights Feedback Form
  'InsightsFeedbackLaunch', // CT81 - Insights Feedback Form
  'AnnualRenewalForm', // CT84 - Annual Renewal Form
  'AsiaPopup', // CT88 - Asia Popup
  'WeChatQR', // CT92 - WeChatQR
  'StaffEnquiryForm', // New Form Component
  'EmbedScript',
];

export const manifest = [...blockComponents, ...normalComponents, ...otherComponents];

const typeGenerator = (arr, type) =>
  arr.reduce((map, component) => {
    map[component] = type;
    return map;
  }, {});

export const componentTypes = {
  ...typeGenerator(blockComponents, 'block'),
  ...typeGenerator(normalComponents, 'normal'),
  ...typeGenerator(otherComponents, 'other'),
};
